export async function aiAsk(q: string): Promise<string> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(
        `AI ESG Advisor: Based on taxonomy correlations, your query "${q}" indicates regulatory pressure on Scope 2 emissions. Suggested: renewable contract + supplier re-score.`
      );
    }, 600);
  });
}

